import React from "react";
import { CallFeature, CallParticipant } from "../../api/graphql";
import retryImport from "../../lib/retryImport";
import VoiceCallInterface from "./VoiceCallInterface";

const TwilioCallConnection = React.lazy(() =>
  retryImport(() => import("./TwilioCallConnection"))
);

type Props = {
  currentParticipant: Pick<CallParticipant, "externalId" | "fullName">;
  call: {
    phoneId: string;
    jwt: string;
    contactName: string;
    number: string;
    features: CallFeature[];
  };
  onLeave: () => void;
  beginMuted: boolean;
  onTerminated: () => void;
  onEnded: () => void;
  alerts: boolean;
  onToggleAlerts: () => void;
  onPeerJoined: () => void;
};

export default function TwilioLiveCall({
  currentParticipant,
  call,
  beginMuted,
  onEnded,
  ...rest
}: Props) {
  return (
    <TwilioCallConnection call={call} muteAudio={beginMuted} onEnded={onEnded}>
      {(connectionInfo) => (
        <VoiceCallInterface
          features={call.features}
          participants={[
            currentParticipant,
            {
              externalId: "twilio-ad-hoc-correspondent",
              fullName: call.contactName,
            },
          ]}
          unlimited={true}
          connectionInfo={connectionInfo}
          currentParticipant={currentParticipant}
          hasKeyboard={true}
          {...rest}
        />
      )}
    </TwilioCallConnection>
  );
}
